/**
 * ? @description : Teachers Attendance Data
 */

// Dependencies
import React, { useState, useEffect, memo } from "react";
import {
  Box,
  Typography,
  TextField,
  Chip,
  Divider,
  Tab,
  IconButton,
  Stack,
  MenuItem,
  TableRow,
  TableCell,
} from "@mui/material";
import { DesktopDatePicker, LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";
import { Dropdown, Modal, Table, Tabs } from "react-bootstrap";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

// MUI Icons
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import dayjs from "dayjs";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import EditAttendanceModal from "../Modals/EditAttendanceModal";
import { Close } from "@mui/icons-material";
import axios from "axios";

function TeachersAttendanceStatusModal(props) {
  // console.log(filteredTeachersData[0]);

  // * Redux Variable
  const dispatch = useDispatch();

  // * Logged Username
  const username = sessionStorage.getItem("username");

  // * State Variables
  const [filterData, setFilterData] = useState([]);
  const [attendedDateDropdown, setAttendedDateDropdown] = useState([]);
  const [fullAttendanceData, setFullAttendanceData] = useState({
    session_date: "",
    session_title: "",
    attendance_postedby: sessionStorage.getItem("user_id"),
    teachersData: [],
  });
  const [viewAttendance, setViewAttendance] = useState('')
  const [teachersDataServer, setTeachersDataServer] = useState([]);
  const [filteredTeachersData, setFilteredTeachersData] = useState([]);
  const [value, setValue] = useState(1);
  const [getAttendanceDataFromServer, setGetAttendanceDataFromServer] = useState([]);
  // console.log(getAttendanceDataFromServer, "get");
  const [postAttendanceDate, setPostAttendanceDate] = useState("");
  const [addLoading, setAddLoading] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);

  const [rowData, setRowData] = useState([]);
  // const [selectedRowDetails, setSelectedRowDetails] = useState(null)
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  // console.log("filter teacher data - ",filteredTeachersData);
  // console.log("teachers data server", teachersDataServer);
  // console.log(postAttendanceDate);
  // console.log(fullAttendanceData);

  // for pagination state 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };

  const [updateDate, setUpdateDate] = useState();
  const [newDate, setNewDate] = useState(new Date());
  const [disable, setDisable] = useState(true);
  const date = updateDate || newDate;
  // console.log(newDate, "date" );
  useEffect(() => {
    if (props.selectedRowData !== null) {
      setTeachersDataServer(props.selectedRowData);
    }
  }, [props.selectedRowData]);


  // TODO : Adding Extra Parameter
  useEffect(() => {
    let arrayOfObjectData = [];

    if (teachersDataServer.length > 0) {
      teachersDataServer.forEach((teacher) => {
        const audioStatus = teacher.audio_status || " not available"
        const checkboxSelection = audioStatus === "approved"
        return arrayOfObjectData.push({
          teacherId: teacher.teacher_id,
          teacherName: teacher.teacher_name,
          batchId: teacher.group_id,
          attendanceStatus: "not attended",
          audioStatus: audioStatus,
          checkboxSelection: checkboxSelection,
        });
      }
      );
      // console.log(teachersDataServer);
    }

    setFilteredTeachersData(arrayOfObjectData);
  }, [teachersDataServer, rowsPerPage]);

  useEffect(() => {
    const controller = axios.CancelToken.source();
    if (!!props.selectedRowData && props.selectedRowData.length > 0) {
      (async () => {
        try {
          const response = await Axios("get", `attendance/session/date/${props.selectedRowData[0].group_id}`, { cancelToken: controller.token });
          if (response.status === 200) {

            const originalDate = response.data.training_date;
            // console.log(originalDate);
            setNewDate(originalDate)
            // const dateObject = parse(response.data.training_date, 'dd-MM-yyyy HH:mm:ss', new Date());
            // const formattedDate = format(dateObject, 'dd/MM/yyyy');
            // const formattedDate = format(parse(originalDate, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy');

            // const dateObject = new Date(formattedDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
            // const newFormattedDate = dateObject.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-');
            setViewAttendance(dayjs(originalDate).format("DD-MM-YYYY"))
            setFullAttendanceData({
              ...fullAttendanceData,
              session_date: originalDate,
            })
            setAttendedDateDropdown(dayjs(originalDate).format("DD/MM/YYYY"))

          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.log(error);
          }

        }
      })()
    }
    return () => {
      controller.cancel();
    }
  }, [props.selectedRowData])

  // * Column Definitions
  const columnHeader = [
    {
      headerName: "Select Teachers",
      // field: "teacherId",
      sortable: true,
      // hide:true,
      filter: true,
      // checkboxSelection: (params)=> params.data.audioStatus === "approved",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      showDisabledCheckboxes: true,
    },
    {
      headerName: "Teacher Name",
      field: "teacherName",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Audio Status",
      field: "audioStatus",
      sortable: true,
      filter: true,
      cellRendererFramework: (params) => {
        const audioStatus = params.data.audioStatus;
        return (
          <span style={{ color: audioStatus === "approved" ? "green" : "red" }}>
            {audioStatus === null ? "Not available" : audioStatus}
          </span>
        )
      }
    },

    {
      headerName: "Group Id",
      field: "batchId",
      sortable: true,
      filter: true,
      hide: true,
    },
  ];

  // disable row style function 

  const getRowStyle = (params) => {
    const audioStatus = params.data.audioStatus;

    if (audioStatus !== "approved") {
      return { background: "lightgray", pointerEvent: "none" };
    }
    return null;
  }

  // disable row  function 

  const isRowSelectable = (params) => {
    // console.log(params)
    return params.data.audioStatus === "approved" && !props.attendanceStatus
  };

  // const onRowSelected = (params) => {
  //   console.log(params);
  // }

  // const dataPopup = (params) => {
  //   console.log(params.data);
  //   // return alert(params)
  // }
  // * onGridReady Function
  const onGridReady = (params) => {
    setFilterData(params.api);
  };

  // * Row Selection Event : "Multiple"
  const rowSelectionType = "multiple";

  // * Store Selected Row Data in Props Variable
  const onSelectionChanged = (event) => {
    // console.log(event.api.getSelectedRows());
    // filteredTeachersData.forEach((teacher) => {
    //   if (event.api.getSelectedRows().includes(teacher)) {
    //     return teacher.attendanceStatus = "attended";
    //   }
    // });
    // console.log(event);
    // if (event.api.getSelectedNodes().some(node => node.data.audioStatus !== 'approved')){
    //   return;
    // }
    const data = filteredTeachersData.map(teacher => {
      if (event.api.getSelectedRows().some(selectedObj => selectedObj.teacherId === teacher.teacherId)) {
        return { ...teacher, attendanceStatus: "attended" }
      }
      return { ...teacher, attendanceStatus: "not attended" }
    })
    // console.log(data);
    // setFilteredTeachersData(prev => {
    //   return prev.map(teacher => {
    //     if(event.api.getSelectedRows().some(selectedObj => selectedObj.teacherId === teacher.teacherId)){
    //       return { ...teacher, attendanceStatus: "attended" }
    //     }
    //     return { ...teacher, attendanceStatus: "not attended" }
    //   })
    // })

    // for (var i = 0; i < filteredTeachersData.length; i++) {
    //   for (var index in event.api.selectionService.selectedNodes) {
    //     if (index === i) {
    //       filteredTeachersData[i].attendanceStatus = "not attended";
    //     }
    //   }
    // }

    // filteredTeachersData.forEach((teacher) => {
    //   if (event.api.getSelectedRows().length > 0) {
    //     for (var i = 0; i < event.api.getSelectedRows().length; i++) {
    //       if (event.api.getSelectedRows()[i].teacherId === teacher.teacherId) {
    //         teacher.attendanceStatus = "attended";
    //         // return {...teacher, attendanceStatus: "attended"}
    //       }
    //     }
    //   }
    // });

    setFullAttendanceData({
      ...fullAttendanceData,
      teachersData: data,
    });
    const hasAttended = data.some((row) => row.attendanceStatus === "attended");
    setDisable(!hasAttended);
    // setDisable(data)
    // console.log(setFullAttendanceData);
    // const selectedRow = event.api.getSelectedRow()[0];
    // selectedRowDetails(selectedRow)
  };
  // console.log(onselectionchange);

  // * Filter Data
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  // * Select All Rows
  // const isRowSelectable = useCallback((rowNode) => {
  //   if (rowNode.data.attendanceStatus === "attended") {
  //     rowNode.selected = true;
  //     return true;
  //   }
  // }, []);

  // ? API Call : Post Method : Submit Attendance Data to Server
  async function submitAttendanceData() {

    try {
      const { session_date, session_title } = fullAttendanceData;
      if (session_date !== "") {
        setAddLoading(true);
        let teacherDetails = [];

        for (let teacher of fullAttendanceData.teachersData) {
          teacherDetails.push({
            teacher_id: teacher.teacherId,
            attendance_status: teacher.attendanceStatus,
          });
        }

        const data = {
          greet_session_datetime: date,
          greet_session_name: null,
          batch_id: filteredTeachersData[0].batchId,
          posted_by: fullAttendanceData.attendance_postedby,
          teachersList: teacherDetails,
        };
        //  console.log(data);
        const options = {
          method: "post",
          url: "/attendance/addattendance",
          auth: true,
          data: data,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );

        if (response.status === 200) {
          setFullAttendanceData(prevState => ({ ...prevState, session_date: "", session_title: "" }))
          setAddLoading(false);

          setIsDetailsModalOpen(false)
          dispatch(
            showSnackbar({
              message: "Attendance added successfully",
              severity: "success",
            })
          );
          props.onClose();
          // window.location.reload();
          props.onCloseCallBack();

        }
      } else {
        setIsDetailsModalOpen(false)
        dispatch(
          showSnackbar({
            message: "Please fill all the fields !",
            severity: "error",
          })
        );
      }
    } catch (error) {
      setAddLoading(false);
      setIsDetailsModalOpen(false)
      dispatch(
        showSnackbar({
          message: "Error, Unable to post data! Please try again later.",
          severity: "error",
        })
      );
    }
  }

  // ! MUIDataTable Logic
  // * Columns Declarations
  const columns = [
    // {
    //   name: "attendance_id",
    //   label: "Attendance Id",
    //   options: {
    //     filter: false,
    //     filterType: "Dropdown",
    //     sort: true,
    //     display: true,
    //     download: false,
    //   },
    // },
    {
      name: "teacher_id",
      label: "Teacher Id",
      options: {
        // hideable: false,
        // customHeadRender: () => null, // hide the column header
        // customBodyRender: (value) => null,// hide the column body
        display: false,
        filter: true,
        filterType: "Dropdown",
        sort: true,
        // display: false,
        download: true,
      },
    },
    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: true,
        download: true,
      },
    },
    {
      name: "batch_id",
      label: "Group id",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: false,
        download: true,
      },
    },
    {
      name: "group_name",
      label: "Group name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: true,
        download: true,
      },
    },
    {
      name: "attendance_id",
      label: "Attendance id",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: false,
        download: true,
      },
    },
    {
      name: "attendance_status",
      label: "Attendance status",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: true,
        download: true,
      },
    },
    {
      name: "greet_session_name",
      label: "Session name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: false,
        download: true,
      },
    },
    {
      name: "greet_session_datetime",
      label: "Session Date",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: true,
        download: true,
        customBodyRender: (value) => {
          // console.log(value);
          // let theDate = new Date(Date.parse(value)).toLocaleString("en-IN", {
          //   timeZone: "Asia/Calcutta",
          // });
          let theDate = dayjs(value).format('DD/MM/YYYY')
          // console.log(theDate);
          return theDate;
        }
      },
    },
    {
      name: "teacher_mapped_status",
      label :"Teacher Mapped Status",
      options: {
        display :false
      }
 
    },

    {
      name: "Action",
      options: {
        filter: false,
        sort: false,
        empty: false,
        download: false,
        customBodyRender: (value, data) => {
          // console.log(data.rowData[8]);
          const attendanceStatus = rowData[5];
          const mappedStatus = data.rowData[8]
          return (
            <Box>
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                >
                  <MoreVertIcon />
                </Dropdown.Toggle>

                {(attendanceStatus === "attended" && mappedStatus !=='mapped') && (
                  <Dropdown.Menu>
                    <Dropdown.Item>
                      <EditAttendanceModal rowData={data.rowData} setGetAttendanceDataFromServer={setGetAttendanceDataFromServer} />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                )
                }
              </Dropdown>
            </Box>
          );
        },
      },
    },
  ];

  // * Options Configuration to Handle Table
  const options = {
    textLabels: {
      body: {
        noMatch: attendedDateDropdown === '' ? "Teacher attendance yet to be added" : "Sorry, No Data available",
      }
    },
    // filter: true,
    // filterType: "dropdown",
    // elevation: 0,
    // rowsPerPage: 5,
    // rowsPerPageOptions: [5, 10, 20],
    // jumpToPage: true,
    // fixedHeader: true,
    // fixedSelectColumn: true,
    // tableBodyHeight: "auto",
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    onRowClick: (rowData) => {
      // console.log(rowData);
      setRowData(rowData);
      // setCommentsToModal(rowData);
    },
    // customSearch: (searchQuery, currentRow, columns) => {
    //   currentRow.forEach(col => {
    //     if (col && col.toString().indexOf(searchQuery) >= 0) {
    //       return setIsDataFetchError(true);
    //     }
    //   });
    // }
    columns: {
      0: {
        display: false,
      }
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  // ? API Call : Post Method : To Get Attendance Data
  async function viewAttendanceData() {
    if (attendedDateDropdown !== "") {
      // console.log(viewAttendance)
      setViewLoading(true);
      try {
        const data = {
          greet_session_datetime: viewAttendance,
          batch_id: filteredTeachersData[0].batchId,
        };
        // console.log(data);
        const options = {
          method: "post",
          url: "attendance/view/attendancelistbybatch",
          auth: true,
          data: data,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );

        if (response.status === 200) {
          // console.log(response.data);
          setViewLoading(false);
          setPostAttendanceDate("");
          // let {result2} = response.data;
          // console.log(response.data);
          // let attendanceData = response.data.result1.map((data, index) => ({...data, ...result2[index]}))
          // console.log(attendanceData);
          setGetAttendanceDataFromServer(response.data);
        } else if (response.status === 202) {
          setViewLoading(false);
          dispatch(
            showSnackbar({
              message: "No attendance data available !",
              severity: "error",
            })
          );
        }

      } catch (error) {
        setViewLoading(false);
        // console.log(error);
        dispatch(
          showSnackbar({
            message: "There is no attendance for the date you entered !",
            severity: "error",
          })
        );
      }
    } else {
      dispatch(
        showSnackbar({
          message: "Please select a date to view attendance",
          severity: "error",
        })
      );
    }
  }
  // console.log(updateDate);
  // API call: Post Method : Edit Attendance Date

  // console.log(updateDate);
  // console.log(filteredTeachersData[0]?.batchId);
  async function EditAttendanceDate() {

    if (updateDate) {
      setViewLoading(true);

      try {
        const data = {
          batch_id: filteredTeachersData[0]?.batchId,
          batch_name: props.currentBatchName,
          training_date_for_batch: updateDate,
        };
        // console.log(data);
        const options = {
          method: 'put',
          url: 'batches/edit/training/date',
          auth: true,
          data: data,
        }
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
        );

        if (response.status === 200) {
          setViewLoading(false);
          dispatch(
            showSnackbar({
              message: "Attendance date updated Successfully!",
              severity: "success",
            })
          );
          setAttendedDateDropdown(dayjs(updateDate).format("DD/MM/YYYY"))
          // setUpdateDate('')
        } else if (response.status === 201) {
          setViewLoading(false);
          dispatch(
            showSnackbar({
              message: response.data,
              severity: "error",
            })
          );
        } else {
          setViewLoading(false);
          dispatch(
            showSnackbar({
              message: "Please try again sometimes!",
              severity: "error",
            })
          );
        }

      } catch (error) {
        setViewLoading(false);
        // console.log(error);
        dispatch(
          showSnackbar({
            message: "Please try again sometimes!",
            severity: "error",
          })
        );
      }
    } else {
      dispatch(
        showSnackbar({
          message: "Please select a date to update attendance",
          severity: "error",
        })
      )
    }

  }



  // ? API Call : Post Method : To Get Attendance Data in useEffect
  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (attendedDateDropdown !== "") {
  //       setViewLoading(true);
  //       console.log(attendedDateDropdown)
  //       try {
  //         const data = {
  //           greet_session_datetime: attendedDateDropdown,

  //           batch_id: filteredTeachersData[0].batchId,
  //         };

  //         const options = {
  //           method: "post",
  //           url: "attendance/view/attendancelistbybatch",
  //           auth: true,
  //           data: data,
  //         };

  //         const response = await Axios(
  //           options.method,
  //           options.url,
  //           options.auth,
  //           options.data
  //         );

  //         if (response.status === 200) {
  //           console.log(response.data);
  //           setViewLoading(false);
  //           setPostAttendanceDate("");
  //           setGetAttendanceDataFromServer(response.data);
  //         }

  //       } catch (error) {
  //         setViewLoading(false);
  //         dispatch(
  //           showSnackbar({
  //             message: "There is no attendance for the date you entered!",
  //             severity: "error",
  //           })
  //         );
  //       }
  //     } else {
  //       dispatch(
  //         showSnackbar({
  //           message: "Please select a date to view attendance",
  //           severity: "error",
  //         })
  //       );
  //     }
  //   };

  //   fetchData(); // Call the async function immediately
  // }, [postAttendanceDate, filteredTeachersData, setViewLoading, setPostAttendanceDate, setGetAttendanceDataFromServer, dispatch,attendedDateDropdown]);

  //* for showing the selected & unSelected teachers name on card 

  function AttendanceDetailsModal({ open, onClose, allData }) {
    const selectedRows = allData.teachersData.filter((row) => row.attendanceStatus === "attended");

    const unselectedRows = allData.teachersData.filter((row) => row.attendanceStatus !== "attended");

    return (

      <Modal
        show={open}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2000, position: 'fixed' }}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>
              Attendance Details&nbsp;
            </h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ height: "50vh", overflow: "scroll" }}>
          <Tabs
            className="mb-3"
            id="uncontrolled-tab-example"
            defaultActiveKey="primary"
          >
            <Tab eventKey="primary" >
              <div>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th style={{ color: "#5afa5f" }}>Selected Teachers</th>
                      <th style={{ color: "#ff3333" }}>Unselected Teachers</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {selectedRows.map((row, index) => (
                          <div key={index}>
                            <p style={{ fontWeight: 600 }}>{row.teacherName}</p>
                            <br />
                          </div>
                        ))}
                      </td>
                      <td>
                        {unselectedRows.map((row, index) => (
                          <div key={index}>
                            <p style={{ fontWeight: 600 }}>{row.teacherName}</p>
                            <br />
                          </div>
                        ))}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>

        <Modal.Footer>
          <div>
            <Button
              type="button"
              variant="light"
              onClick={onClose}
            >
              CANCEL
            </Button>
          </div>

          <div>
            <LoadingButton
              type="submit"
              variant="contained"
              onSubmit={onClose}
              loading={addLoading}
              onClick={() => {
                // console.log("submitted");
                submitAttendanceData()
              }}
            >
              Submit
            </LoadingButton>
          </div>
        </Modal.Footer>

      </Modal>
    );
  }
  const openDetailsModal = () => {
    setIsDetailsModalOpen(true);
  };
  const handleClose = () => {
    props.onClose();
    setValue(1)
    // window.location.reload();
    // props.onCloseCallBack()
    setGetAttendanceDataFromServer()
  }

  return (
    props.selectedRowData !== null && (
      <Dialog
        maxWidth="lg"
        fullWidth
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-content"
      >
        <Box>
          <Stack direction="row" justifyContent="space-between" p={2}>
            <Typography variant="h6" component="div">
            Training details
            </Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
          <Divider></Divider>
          <TabContext value={value}>
            {/* Tab Headers */}
            <Box>
              <TabList
                aria-label="Tabs Header"
                onChange={(e, newValue) => setValue(newValue)}
              >
                <Tab label="Add" value={1} />
                <Tab label="View" value={2}
                  onClick={() => viewAttendanceData()}
                />
              </TabList>
            </Box>

            <TabPanel value={1}>
              {/* Input Fields */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2rem"
                  }}
                >
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    sx={{ width: 200 }}
                    label="Training date"
                    disablePast
                    // disabled={disableCalender}
                    defaultValue={dayjs(attendedDateDropdown).format("DD/MM/YYYY")}
                    value={attendedDateDropdown ? dayjs(attendedDateDropdown) : null}          
                            // defaultValue={dayjs('12/12/1197')}
                            // defaultValue={dayjs('2022-04-17')}
                    // onChange={(date) =>
                    //   setFullAttendanceData({
                    //     ...fullAttendanceData,
                    //     session_date: dayjs(date["$d"]).format("YYYY-MM-DD"),
                    //   })
                    // }
                    // onAccept={(date) => {
                    //   console.log("Accepted date:", date); 
                    // }}
                    onChange={(date)=> setUpdateDate(dayjs(date["$d"]).format("YYYY-MM-DD"))}
                    format="DD/MM/YYYY"
                    slots={{
                      textField: (params) => <TextField
                        size="small"
                        value={attendedDateDropdown ? dayjs(attendedDateDropdown).format("DD/MM/YYYY") : "" }
                        {...params}
                      />
                    }}
                  />
                </LocalizationProvider> */}

                  <TextField
                    // required
                    type="date"
                    variant="outlined"
                    size="small"
                    name="title"

                    label="Training date"
                    inputProps={{
                      autoComplete: "off",
                      placeholder: newDate || "Select a date",
                      onFocus: (e) => (e.target.type = 'date'),
                      min: dayjs(new Date()).format("YYYY-MM-DD")
                      // onBlur: (e) => (e.target.type = 'text'),
                    }}
                    sx={{ width: 200, fontWeight: 700 }}
                    defaultValue={newDate}
                    value={newDate}
                    // onChange={(e) =>
                    //   setFullAttendanceData({
                    //     ...fullAttendanceData,
                    //     session_date:attendedDateDropdown,
                    //   })
                    // }
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      setUpdateDate(dayjs(selectedDate).format("YYYY-MM-DD"));
                      setNewDate(e.target.value);
                      // console.log(dayjs(selectedDate).format("YYYY-MM-DD"));
                    }}
                  />

                  {/* Buttons */}

                  {!props.attendanceStatus &&

                    <Box
                      sx={{
                        mt: "16px",
                        mb: "16px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >

                      <LoadingButton
                        type="submit"
                        variant="contained"
                        disabled={attendedDateDropdown === 0}
                        loading={viewLoading}
                        color="primary"
                        onClick={EditAttendanceDate}
                      >
                        Change date
                      </LoadingButton>
                    </Box>
                  }

                </Box>

                <Box>
                  <TextField
                    type="search"
                    name="search"
                    variant="outlined"
                    size="small"
                    label="Search Here"
                    placeholder="Eg : John Doe"
                    InputProps={{ autoComplete: "off" }}
                    sx={{ width: 400 }}
                    onChange={onFilterTextChange}
                  />
                </Box>
                <TextField
                  type="text"
                  variant="outlined"
                  size="small"
                  name="postBy"
                  label="Attendance Post By"
                  placeholder="Admin Name"
                  InputProps={{ autoComplete: "off" }}
                  sx={{ width: 200 }}
                  value={username}
                />
              </Box>

              {/* Search Field & Note Message */}
              <Box
                sx={{
                  mt: "16px",
                  mb: "16px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* <Box>
                  <TextField
                    type="search"
                    name="search"
                    variant="outlined"
                    size="small"
                    label="Search Here"
                    placeholder="Eg : John Doe"
                    InputProps={{ autoComplete: "off" }}
                    sx={{ width: 200 }}
                    onChange={onFilterTextChange}
                  />
                </Box> */}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    // alignItems: "center",
                  }}
                >
                  <Typography variant="p" component="div" style={{ fontWeight: "700" }}>
                    Instruction &nbsp;:&nbsp;
                  </Typography>
                  <Box>
                    <ul>
                      <li>Deselect the row for not attended trainee !</li>
                      <li>While changing the training date. It should be greater than one day from the current date</li>
                    </ul>
                  </Box>
                  {/* <Chip
                    label="Deselect the row for not attended trainee !"
                    color="error"
                  /> */}

                </Box>
              </Box>

              {/* Table */}
              <Box
                className="ag-theme-alpine my-3"
                sx={{ width: "100%", height: "310px" }}
              >
                <AgGridReact
                  defaultColDef={{ flex: 1, isSelected: true }}
                  onGridReady={onGridReady}
                  rowData={filteredTeachersData}
                  columnDefs={columnHeader}
                  rowSelection={rowSelectionType}
                  onSelectionChanged={onSelectionChanged}
                  rowMultiSelectWithClick={true}
                  pagination={true}
                  paginationPageSize={10}
                  paginationAutoPageSize={true}
                  // isRowSelectable={isRowSelectable}

                  // getRowNodeId={options.getRowNodeId}
                  getRowStyle={getRowStyle}
                  isRowSelectable={isRowSelectable}
                // onRowSelected={onRowSelected}
                />
              </Box>

              {!props.attendanceStatus &&

                <Box
                  sx={{
                    mt: "8px",
                    mb: "8px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={addLoading}
                    disabled={disable}
                    color="primary"
                    sx={{ ml: "8px" }}
                    onClick={() => {
                      // console.log("clicked");
                      setIsDetailsModalOpen(true)
                    }}
                  >
                    Add Attendance
                  </LoadingButton>
                  <AttendanceDetailsModal
                    allData={fullAttendanceData}
                    open={isDetailsModalOpen}
                    onClose={() => setIsDetailsModalOpen(false)}
                  />
                </Box>
              }
            </TabPanel>

            <TabPanel value={2}>
              {/* User Input & Actions */}
              <Box
                sx={{
                  height: "auto",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                {/* Input Field */}
                <Box>
                  <TextField
                    sx={{ width: 200, mr: "16px" }}
                    size="small"
                    // select={attendedDateDropdown.length > 0}
                    // disabled={attendedDateDropdown.length === 0}
                    disabled
                    label="Session Date"
                    value={attendedDateDropdown}
                  // onChange={(e) =>
                  //   setPostAttendanceDate(e.target.value)
                  // }
                  >
                    {/* {attendedDateDropdown?.map((item, i) => (
                      <MenuItem key={i} value={item.date.split(" ")[0]}>{item.date.split(" ")[0]}</MenuItem>
                    ))} */}
                  </TextField>
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    mt: "16px",
                    mb: "16px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >

                  {/* <LoadingButton
                    type="submit"
                    variant="contained"
                    disabled={attendedDateDropdown === 0}
                    loading={viewLoading}
                    color="primary"
                    onClick={viewAttendanceData}
                  >
                    View
                  </LoadingButton> */}
                </Box>
              </Box>

              {/* Table */}
              <MUIDataTable
                title="Teacher Attendance"
                data={getAttendanceDataFromServer}
                columns={columns}
                options={options}
                components={{ TableFilterList: CustomFilterList }}
              />
            </TabPanel>
          </TabContext>
        </Box>
      </Dialog>
    )
  );
}

export default memo(TeachersAttendanceStatusModal);
